import { Add, Check } from '@mui/icons-material'
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tab,
  Tabs,
  TextField,
  Typography,
} from '@mui/material'
import { blue, grey } from '@mui/material/colors'
import React, { useEffect, useState } from 'react'
import SupportSection from './SupportSection'
import { removeItemAtIndex, updateObjectAtIndex } from '../../../utils/array'
import useGenericEndpoint from '../../../hooks/api/useGenericEndpoint'
import { authedAxios } from '../../../utils'
import useAlert from '../../../hooks/useAlert'

const SupportSections = () => {
  const [tab, setTab] = useState(0)

  const [sections, setSections] = useState([])

  const [isAddingSection, setIsAddingSection] = useState(false)

  const [newSectionName, setNewSectionName] = useState('')

  const { createGenericErrorAlert, createAlert } = useAlert()

  const { data, isLoading } = useGenericEndpoint(
    '/api/superadmin/support-sections'
  )

  const putData = () => {
    return authedAxios
      .put('/api/superadmin/support-sections', { sections })
      .then(() => {
        createAlert({ message: 'Saved successfully' })
      })
      .catch(() => createGenericErrorAlert())
  }

  useEffect(() => {
    if (isLoading) return
    setSections(data?.sections || [])
  }, [data, isLoading])

  const addSection = () => {
    if (newSectionName.length === 0) return
    if (sections.map((s) => s.name).includes(newSectionName)) return

    setSections((prev) => [
      ...prev,
      {
        name: newSectionName,
        generalUsersCanSee: false,
        subsections: [],
      },
    ])
    setNewSectionName('')
    setIsAddingSection(false)
    setTab(sections.length)
  }

  const setSection = (newVal, index) => {
    setSections(updateObjectAtIndex(sections, newVal, index))
  }

  const removeSection = (index) => {
    setSections(removeItemAtIndex(sections, index))

    setTab(Math.max(0, tab - 1))
  }

  const selectedSection = sections[tab]

  if (isLoading) return <CircularProgress />

  return (
    <Box sx={{ alignSelf: 'stretch' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant={'contained'} onClick={() => putData()}>
          Save
        </Button>
      </Box>
      <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <Box sx={{ mr: 2, width: '225px' }}>
          <Typography sx={{ mt: 2 }}>Support Sections</Typography>
          {sections.length > 0 && (
            <Tabs
              orientation='vertical'
              sx={{
                mt: 1,
                flexShrink: 0,
                maxHeight: '400px',
                backgroundColor: 'white',
                border: `1px solid ${grey[300]}`,

                flexShrink: 0,
              }}
              value={tab}
              onChange={(_e, val) => setTab(val)}
              variant='scrollable'
            >
              {sections.map((s, i) => {
                return (
                  <Tab
                    sx={{
                      alignItems: 'start',
                      borderTop: `1px solid ${grey[200]}`,
                      backgroundColor: tab === i ? blue[50] : null,
                    }}
                    key={i}
                    label={s.name}
                  ></Tab>
                )
              })}
            </Tabs>
          )}
          <Box>
            {!isAddingSection && (
              <Button
                endIcon={<Add />}
                onClick={() => setIsAddingSection(true)}
              >
                Add a section
              </Button>
            )}
            {isAddingSection && (
              <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
                <TextField
                  autoFocus
                  fullWidth
                  label={'New Section Name'}
                  value={newSectionName}
                  onChange={(e) => setNewSectionName(e.target.value)}
                  InputProps={{
                    endAdornment: (
                      <IconButton color='primary' onClick={addSection}>
                        <Check />
                      </IconButton>
                    ),
                  }}
                ></TextField>
              </Box>
            )}
          </Box>
        </Box>
        <Box sx={{ flexGrow: 1, backgroundColor: grey[100], p: 2 }}>
          {selectedSection && (
            <SupportSection
              section={selectedSection}
              setSection={(val) => setSection(val, tab)}
              removeSection={() => removeSection(tab)}
            />
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default SupportSections
